// extracted by mini-css-extract-plugin
export default {"container":"Siding_container__eE6K1","productListContainer":"Siding_productListContainer__djWbX","productGrid":"Siding_productGrid__zEdE9"};